import { SvgIconProps } from './icon-props';

export default function ExclusiveAmenitiesFilled({ height = 32, width = 32 }: SvgIconProps) {
	return (
		<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
			<path d="m11.4 11.22-8.92 1.4h-.09a.56.56 0 0 0-.21.94l6.41 6.1-1.4 8.7v.1A.56.56 0 0 0 8 29l8-4 8 4h.09a.56.56 0 0 0 .71-.63l-1.4-8.7 6.4-6.1.07-.07a.57.57 0 0 0-.37-.89l-8.92-1.4L16.5 3.4a.56.56 0 0 0-1 0z" />
		</svg>
	);
}
